import { cardsInfo } from "pages/privacy";
import { ComponentType, FC } from "react";
import * as styles from "./styles.module.scss";

type Card = {
    title: string;
    icon: ComponentType;
    handleClick: (id: string) => void;
    id: string;
    activeSection: string | null;
};

const Card: FC<Card> = ({ title, icon, handleClick, id, activeSection }) => {
    const Icon = icon;

    return (
        <div
            className={`${styles.cardWrapper} ${activeSection === id ? styles.active : ""}`}
            onClick={() => handleClick(id)}
        >
            <div className={styles.icon}>
                <Icon />
            </div>

            <p className={styles.title}>{title}</p>
        </div>
    );
};

type WhatsInsideSidebarPrivacy = {
    handleClick: (id: string) => void;
    activeSection: string | null;
};

export const WhatsInsideSidebarPrivacy: FC<WhatsInsideSidebarPrivacy> = ({ handleClick, activeSection }) => {
    return (
        <div className={styles.wrapper}>
            <p className={styles.sidebarTitle}>What's Inside?</p>

            <div className="flex items-center gap-[1%]">
                {cardsInfo.map((item, index) => (
                    <Card activeSection={activeSection} handleClick={handleClick} key={index} {...item} />
                ))}
            </div>
        </div>
    );
};
